import { DesktopCollectionCard } from "../../../components/cards/DesktopCollectionCard";
import type { AnalyticsItemList } from "../../../tools/analytics/analytics.types";
import { useCurrentUser } from "../../user/hooks/useCurrentUser";
import type { ApiPlaylistModel } from "../hooks/useGetRecommendedPlaylistsQuery";
import { useSavePlaylist } from "../hooks/useSavePlaylist";

/**
 * A desktop collection card wired to the reader's saved collections. The
 * bookmark shows only on a collection the reader can save: not one they own,
 * not one shared with them, since both already live on their profile.
 */
export function SaveableCollectionCard({
  playlist,
  listName,
  onOpen,
}: {
  playlist: ApiPlaylistModel;
  listName: AnalyticsItemList;
  onOpen: () => void;
}): React.JSX.Element {
  const { currentUser } = useCurrentUser();
  const { isSaved, toggleSave } = useSavePlaylist(playlist, listName);
  const canSave =
    currentUser !== null &&
    playlist.userId !== currentUser.id &&
    !playlist.sharedWithUserIds.includes(currentUser.id);

  return (
    <DesktopCollectionCard
      playlist={playlist}
      onOpen={onOpen}
      bookmark={
        canSave
          ? {
              isSaved,
              onToggle: () => {
                void toggleSave();
              },
            }
          : null
      }
    />
  );
}
